export type IProductItem = {
    variantId: string;
    desc: string;
    link: string;
    tips: string;
    priceDesc: string;
    save: string;
    message: string;
    detailsLink?: string;
    // 接口注入
    productTitle?: string;
    img?: string;
    price?: number;
};

export const products: Record<string, IProductItem[]> = {
    eu: [
        {
            variantId: '50396945482071',
            tips: 'First Choice',
            desc: 'Includes:\n1 × EcoFlow STREAM Ultra',
            save: '',
            priceDesc: 'Early Bird Price: €1.199 (with deposit, valid until 29 Apr) Original Price: €1.299',
            message: 'Early Bird Price: €1.199 (with deposit, valid until 29 Apr)\nOriginal Price: €1.299',
            link: 'https://eu.ecoflow.com/pages/generate-checkout?variantId=50396945482071&purchaseOption=691099697495',
            detailsLink: 'https://eu.ecoflow.com/products/stream-series-plug-in-solar-battery?variant=50396945482071',
        },
        {
            variantId: '50245703172439',
            tips: 'Flexible DIY Solar Network',
            desc: 'Includes: 1 × EcoFIow STREAM Ultra & 1 × EcoFIow STREAM AC Pro',
            priceDesc: 'Back to €1,848 on 30 April',
            save: '',
            message: 'Early Bird Price: €2.099 (with deposit, valid until 29 Apr)\nOriginal Price: €2.298',
            link: 'https://eu.ecoflow.com/pages/generate-checkout?variantId=50245703172439&purchaseOption=691099697495',
            detailsLink: 'https://eu.ecoflow.com/products/stream-series-plug-in-solar-battery?variant=50245703172439',
        },
        {
            variantId: '50245703139671',
            tips: 'Ideal for 90–119m² Home Size',
            desc: 'Includes: 2 × 520W Rigid Solar Panels & 1 × EcoFIow STREAM Ultra',
            priceDesc: 'Back to €1,848 on 30 April',
            save: 'Save €397 per Year',
            message: 'Early Bird Price: €1.569 (with deposit, valid until 29 Apr)\nOriginal Price: €1.659',
            link: 'https://eu.ecoflow.com/pages/generate-checkout?variantId=50245703139671&purchaseOption=691099697495',
            detailsLink: 'https://eu.ecoflow.com/products/stream-series-plug-in-solar-battery?variant=50245703139671',
        },
        {
            variantId: '50245703205207',
            tips: 'Flexible DIY Solar Network',
            desc: 'Includes: 4 × 520W Rigid Solar Panels & 1 × EcoFlow STREAM Ultra',
            priceDesc: 'Back to €2,298 on 30 April',
            save: 'Save €793 per Year',
            message: 'Early Bird Price: €1.909 (with deposit, valid until 29 Apr)\nOriginal Price: €2.298',
            link: 'https://eu.ecoflow.com/pages/generate-checkout?variantId=50245703205207&purchaseOption=691099697495',
            detailsLink: 'https://eu.ecoflow.com/products/stream-series-plug-in-solar-battery?variant=50245703205207',
        },
        {
            variantId: '50245703237975',
            tips: 'Solar Energy for Anytime Use',
            desc: 'Includes:\n4 × 520W Rigid Solar Panels\n1 × EcoFlow STREAM Ultra\n2 × EcoFlow STREAM AC Pro',
            priceDesc: '1848 € on May 15th',
            save: '0% Waste',
            message: 'Early Bird Price: €3.809 (with deposit, valid until 29-Apr)\nOriginal Price: €4.019',
            link: 'https://eu.ecoflow.com/pages/generate-checkout?variantId=50245703237975&purchaseOption=691099697495',
            detailsLink: 'https://eu.ecoflow.com/products/stream-series-plug-in-solar-battery?variant=50245703237975',
        },
        {
            variantId: '50245703270743',
            tips: 'Plug & Play Residential Solar Solution',
            desc: 'Includes:\n4 × 520W Rigid Solar Panels\n2 × 450W Rigid Solar Panels\n1 × EcoFlow STREAM Ultra \n3 × EcoFlow STREAM AC Pro\n1 × Microinverter',
            priceDesc: 'Back to €6,112 on 30 April',
            save: 'Save €1.109 per Year',
            message: 'Early Bird Price: €6.419 (with deposit, valid until 29-Apr)\nOriginal Price: €6.765',
            link: 'https://eu.ecoflow.com/pages/generate-checkout?variantId=50245703270743&purchaseOption=691099697495',
            detailsLink: 'https://eu.ecoflow.com/products/stream-series-plug-in-solar-battery?variant=50245703270743',
        },
    ],
    de: [
        {
            variantId: '55738978959741',
            tips: 'Top-Wahl',
            desc: ' Enthält:\nb1 × EcoFlow STREAM Ultra',
            priceDesc: 'ab 30. April wieder 1 848 €',
            save: '',
            message: ' Early-Bird-Preis: 999 € (mit Anzahlung, gültig bis 29.04)\nUVP: 1 099 €',
            link: 'https://de.ecoflow.com/pages/generate-checkout?variantId=55738978959741&purchaseOption=710509658493',
            detailsLink: 'https://de.ecoflow.com/products/stream-series-plug-in-solar-battery?variant=55738978959741',
        },
        {
            variantId: '55583410618749',
            tips: 'Flexibles DIY Solarnetzwerk',
            desc: ' Enthält:\n1 × EcoFlow STREAM Ultra\n1 × EcoFlow STREAM AC Pro',
            priceDesc: 'ab 30. April wieder 2 298 €',
            save: '',
            message: 'Early-Bird-Preis: 1 699 € (mit Anzahlung, gültig bis 29.04)\nUVP: 1 898 €',
            link: 'https://de.ecoflow.com/pages/generate-checkout?variantId=55583410618749&purchaseOption=710509658493',
            detailsLink: 'https://de.ecoflow.com/products/stream-series-plug-in-solar-battery?variant=55583410618749',
        },
        {
            variantId: '55583410585981',
            tips: 'Ideal für Wohnflächen von 90-119 m²',
            desc: ' Enthält:\n2 × 520 W Starre Solarpanels\n1 × EcoFlow STREAM Ultra',
            priceDesc: 'ab 30. April wieder 1 848 €',
            save: 'Sparen Sie 397 € pro Jahr',
            message: 'Early-Bird-Preis: 1 329 € (mit Anzahlung, gültig bis 29.04)\nUVP: 1 548 €',
            link: 'https://de.ecoflow.com/pages/generate-checkout?variantId=55583410585981&purchaseOption=710509658493',
            detailsLink: 'https://de.ecoflow.com/products/stream-series-plug-in-solar-battery?variant=55583410585981',
        },
        {
            variantId: '55583410651517',
            desc: ' Enthält:\n4 × 520 W Starre Solarpanels\n1 × EcoFlow STREAM Ultra',
            tips: 'Ideal für Wohnflächen von 120-149 m² ',
            priceDesc: 'ab 30. April wieder 2 033 €',
            save: 'Sparen Sie 793 € pro Jahr',
            message: ' Early-Bird-Preis: 1 609 € (mit Anzahlung, gültig bis 29.04)\nUVP: 1 997 €',
            link: 'https://de.ecoflow.com/pages/generate-checkout?variantId=55583410651517&purchaseOption=710509658493',
            detailsLink: 'https://de.ecoflow.com/products/stream-series-plug-in-solar-battery?variant=55583410651517',
        },
        {
            variantId: '55583410684285',
            desc: 'Enthält:\n4 × 520 W Starre Solarpanels\n1 × EcoFlow STREAM Ultra\n2 × EcoFlow STREAM AC Pro',
            tips: 'Solarenergie jederzeit nutzbar',
            priceDesc: 'ab 30. April wieder 4 031 €',
            save: '0 % Energieverlust',
            message: ' Early-Bird-Preis: 3 129 € (mit Anzahlung, gültig bis 29.04)\nUVP: 4 019 €',
            link: 'https://de.ecoflow.com/pages/generate-checkout?variantId=55583410684285&purchaseOption=710509658493',
            detailsLink: 'https://de.ecoflow.com/products/stream-series-plug-in-solar-battery?variant=55583410684285',
        },
        {
            variantId: '55583410717053',
            desc: ' Enthält:\n4 × 520 W Starre Solarpanels\n2 × 450 W Starre Solarpanels\n1 × EcoFlow STREAM Ultra\n3 × EcoFlow STREAM AC Pro\n1 × Mikro-Wechselrichter',
            tips: 'Plug & Play Solarlösung für Privathaushalte',
            priceDesc: 'ab 30. April wieder 6 112 €',
            save: 'Sparen Sie 1 109 € pro Jahr',
            message: ' Early-Bird-Preis: 5 299 € (mit Anzahlung, gültig bis 29.04)\nUVP: 6 071 €',
            link: 'https://de.ecoflow.com/pages/generate-checkout?variantId=55583410717053&purchaseOption=710509658493',
            detailsLink: 'https://de.ecoflow.com/products/stream-series-plug-in-solar-battery?variant=55583410717053',
        },
    ],
    fr: [
        {
            variantId: '50393675891035',
            desc: 'Comprend :\n1 × EcoFlow STREAM Ultra',
            tips: 'Premier Choix',
            priceDesc: 'retour à 1 848 € le 30 avril',
            save: '',
            message: "Prix Early Bird : 1 199 € (avec acompte, valable jusqu'au 29 avril)\nPrix d'origine : 1 299 €",
            link: 'https://fr.ecoflow.com/pages/generate-checkout?variantId=50393675891035&purchaseOption=693334770011',
        },
        {
            variantId: '50286857093467',
            desc: 'Comprend :\n1 × EcoFlow STREAM Ultra\n1 × EcoFlow STREAM AC Pro',
            tips: 'Réseau solaire flexible',
            priceDesc: 'retour à 2 298 € le 30 avril',
            save: '',
            message: "Prix Early Bird : 2 099 € (avec acompte, valable jusqu'au 29 avril)\nPrix d'origine : 2 298 €",
            link: 'https://fr.ecoflow.com/pages/generate-checkout?variantId=50286857093467&purchaseOption=693334770011',
        },
        {
            variantId: '50286857060699',
            desc: 'Comprend :\n2 × panneaux solaires rigides de 520 W\n1 × EcoFlow STREAM Ultra',
            tips: 'Idéal pour une maison de 90 à 119 m²',
            priceDesc: 'retour à 1 848 € le 30 avril',
            save: 'Économisez 262 € par an',
            message: "Prix Early Bird : 1 569 € (avec acompte, valable jusqu'au 29 avril)\nPrix d'origine : 1 659 €",
            link: 'https://fr.ecoflow.com/pages/generate-checkout?variantId=50286857060699&purchaseOption=693334770011',
        },
        {
            variantId: '50286857126235',
            desc: 'Comprend :\n4 × panneaux solaires rigides de 520 W\n1 × EcoFlow STREAM Ultra',
            tips: 'Idéal pour un logement de 120 à 149 m²',
            priceDesc: 'retour à 2 033 € le 30 avril',
            save: 'Économisez 393 € par an',
            message: "Prix Early Bird : 1 909 € (avec acompte, valable jusqu'au 29 avril)\nPrix d'origine : 2 298 €",
            link: 'https://fr.ecoflow.com/pages/generate-checkout?variantId=50286857126235&purchaseOption=693334770011',
        },
        {
            variantId: '50286857159003',
            desc: 'Comprend :\n4 × panneaux solaires rigides de 520 W\n1 × EcoFlow STREAM Ultra\n2 × EcoFlow STREAM AC Pro',
            tips: 'Énergie solaire pour une utilisation à tout moment',
            priceDesc: 'retour à 4 031 € le 30 avril',
            save: 'Zéro gaspillage',
            message: "Prix Early Bird : 3 809 € (avec acompte, valable jusqu'au 29 avril)\nPrix d'origine : 4 019 €",
            link: 'https://fr.ecoflow.com/pages/generate-checkout?variantId=50286857159003&purchaseOption=693334770011',
        },
        {
            variantId: '50286857191771',
            desc: 'Comprend :\n4 × panneaux solaires rigides de 520 W\n2 × panneaux solaires rigides de 450 W\n1 × EcoFlow STREAM Ultra\n3 × EcoFlow STREAM AC Pro\n1 × micro-onduleur',
            tips: 'Solution solaire résidentielle',
            priceDesc: 'retour à 6 112 € le 30 avril',
            save: 'Économisez 732 € par an',
            message: "Prix Early Bird : 6 419 € (avec acompte, valable jusqu'au 29 avril)\nPrix d'origine : 6 765 €",
            link: 'https://fr.ecoflow.com/pages/generate-checkout?variantId=50286857191771&purchaseOption=693334770011',
        },
    ],
    it: [
        {
            variantId: '55011791634808',
            desc: 'Include:\n1 × EcoFlow STREAM Ultra',
            tips: 'Prima Scelta',
            priceDesc: 'nuovamente 1.848 € dal 30 aprile',
            save: '',
            message: 'Prezzo Early Bird: 1.199 € (con acconto, valido fino al 29 aprile)\nPrezzo originale: 1.299 €',
            link: 'https://it.ecoflow.com/pages/generate-checkout?variantId=55011791634808&purchaseOption=710883574136',
        },
        {
            variantId: '54987832328568',
            desc: 'Include:\n1 × EcoFlow STREAM Ultra\n1 × EcoFlow STREAM AC Pro',
            tips: 'Rete solare flessibile',
            priceDesc: 'nuovamente 2.298 € dal 30 aprile',
            save: '',
            message: 'Prezzo Early Bird: 2.099 € (con acconto, valido fino al 29 aprile)\nPrezzo originale: 2.298 €',
            link: 'https://it.ecoflow.com/pages/generate-checkout?variantId=54987832328568&purchaseOption=710883574136',
        },
        {
            variantId: '54987832295800',
            desc: 'Include:\n2 × pannelli solari rigidi da 520 W\n1 × EcoFlow STREAM Ultra',
            tips: 'Ideale per abitazioni di 90-119 m²',
            priceDesc: 'nuovamente 1.848 € dal 30 aprile',
            save: 'Risparmia 390 € all’anno',
            message: 'Prezzo Early Bird: 1.569 € (con acconto, valido fino al 29 aprile)\nPrezzo originale: 1.659 €',
            link: 'https://it.ecoflow.com/pages/generate-checkout?variantId=54987832295800&purchaseOption=710883574136',
        },
        {
            variantId: '54987832361336',
            desc: 'Include:\n4 × pannelli solari rigidi da 520 W\n1 × EcoFlow STREAM Ultra',
            tips: 'Ideale per abitazioni di 120-149 m²',
            priceDesc: 'nuovamente 2.033 € dal 30 aprile',
            save: 'Risparmia 585 € all’anno',
            message: 'Prezzo Early Bird: 1.909 € (con acconto, valido fino al 29 aprile)\nPrezzo originale: 2.298 €',
            link: 'https://it.ecoflow.com/pages/generate-checkout?variantId=54987832361336&purchaseOption=710883574136',
        },
        {
            variantId: '54987832394104',
            desc: 'Include:\n4 × pannelli solari rigidi da 520 W\n1 × EcoFlow STREAM Ultra\n2 × EcoFlow STREAM AC Pro',
            tips: 'Energia solare da usare quando vuoi',
            priceDesc: 'nuovamente 4.031 € dal 30 aprile',
            save: 'Zero sprechi',
            message: 'Prezzo Early Bird: 3.809 € (con acconto, valido fino al 29 aprile)\nPrezzo originale: 4.019 €',
            link: 'https://it.ecoflow.com/pages/generate-checkout?variantId=54987832394104&purchaseOption=710883574136',
        },
        {
            variantId: '54987832426872',
            desc: 'Include:\n4 × pannelli solari rigidi da 520 W\n2 × pannelli solari rigidi da 450 W\n1 × EcoFlow STREAM Ultra\n3 × EcoFlow STREAM AC Pro\n1 × Microinverter',
            tips: 'Soluzione solare residenziale',
            priceDesc: 'nuovamente 6.112 € dal 30 aprile',
            save: 'Risparmia 1.090 € all’anno',
            message: 'Prezzo Early Bird: 6.419 € (con acconto, valido fino al 29 aprile)\nPrezzo originale: 6.765 €',
            link: 'https://it.ecoflow.com/pages/generate-checkout?variantId=54987832426872&purchaseOption=710883574136',
        },
    ],
    es: [
        {
            variantId: '50393711870299',
            desc: ' Incluye:\n1 × EcoFlow STREAM Ultra',
            tips: 'Primera Opción',
            priceDesc: 'su precio volverá a ser de 1848€ el 30 de abril',
            save: '',
            message: ' Precio Early Bird: 1.199€ (con depósito, válido hasta el 29 de abril)\nPrecio original: 1.299€',
            link: 'https://es.ecoflow.com/pages/generate-checkout?variantId=50393711870299&purchaseOption=693334802779',
        },
        {
            variantId: '50286854832475',
            desc: 'Incluye:\n1 × EcoFlow STREAM Ultra\n1 × EcoFlow STREAM AC Pro',
            tips: 'Red Solar Flexible DIY',
            priceDesc: 'su precio volverá a ser de 2298€ el 30 de abril',
            save: '',
            message: ' Precio Early Bird: 2.099€ (con depósito, válido hasta el 29 de abril)\nPrecio original: 2.298€',
            link: 'https://es.ecoflow.com/pages/generate-checkout?variantId=50286854832475&purchaseOption=693334802779',
        },
        {
            variantId: '50286854799707',
            desc: 'Incluye:\n2 × Placas solares rígidas de 520W\n1 × EcoFlow STREAM Ultra',
            tips: 'Ideal para viviendas de 90–119 m²',
            priceDesc: 'su precio volverá a ser de 1848€ el 30 de abril',
            save: 'Ahorra 294€ al año',
            message: ' Precio Early Bird: 1.569€ (con depósito, válido hasta el 29 de abril)\nPrecio original: 1.659€',
            link: 'https://es.ecoflow.com/pages/generate-checkout?variantId=50286854799707&purchaseOption=693334802779',
        },
        {
            variantId: '50286854865243',
            desc: 'Incluye:\n4 × Placas solares rígidas de 520W\n1 × EcoFlow STREAM Ultra',
            tips: 'Ideal para viviendas de 120–149 m²',
            priceDesc: 'su precio volverá a ser de 2033€ el 30 de abril',
            save: 'Ahorra 440€ al año',
            message: ' Precio Early Bird: 1.909€ (con depósito, válido hasta el 29 de abril)\nPrecio original: 2.298€',
            link: 'https://es.ecoflow.com/pages/generate-checkout?variantId=50286854865243&purchaseOption=693334802779',
        },
        {
            variantId: '50286854898011',
            desc: 'Incluye:\n4 × Placas solares rígidas de 520W\n1 × EcoFlow STREAM Ultra\n2 × EcoFlow STREAM AC Pro',
            tips: 'Energía Solar para Uso en Cualquier Momento',
            priceDesc: 'su precio volverá a ser de 4031€ el 30 de abril',
            save: '0% de Desperdicio',
            message: ' Precio Early Bird: 3.809€ (con depósito, válido hasta el 29 de abril)\nPrecio original: 4.019€',
            link: 'https://es.ecoflow.com/pages/generate-checkout?variantId=50286854898011&purchaseOption=693334802779',
        },
        {
            variantId: '50286854930779',
            desc: 'Incluye:\n4 × Placas solares rígidas de 520W\n2 × Placas solares rígidas de 450W\n1 × EcoFlow STREAM Ultra\n3 × EcoFlow STREAM AC Pro\n1 × Microinversor',
            tips: 'Solución Solar Residencial Plug & Play',
            priceDesc: 'su precio volverá a ser de 6112€ el 30 de abril',
            save: 'Ahorra 820€ al año',
            message: ' Precio Early Bird: 6.419€ (con depósito, válido hasta el 29 de abril)\nPrecio original: 6.765€',
            link: 'https://es.ecoflow.com/pages/generate-checkout?variantId=50286854930779&purchaseOption=693334802779',
        },
    ],
    uk: [
        {
            variantId: '50758705021267',
            desc: 'Includes:\n1 × EcoFlow STREAM Ultra',
            tips: 'First Choice',
            priceDesc: 'Back to £1,548 on 30 April',
            save: '',
            message: 'Early Bird Price: £999 (with deposit, valid until 29 Apr)\nOriginal Price: £1,099',
            link: 'https://uk.ecoflow.com/pages/generate-checkout?variantId=50758705021267&purchaseOption=690042765651',
        },
        {
            variantId: '50633613836627',
            desc: 'Includes:\n1 × EcoFlow STREAM Ultra\n1 × EcoFlow STREAM AC Pro',
            tips: 'Flexible DIY Solar Network',
            priceDesc: 'Back to £1,898 on 30 April',
            save: '',
            message: 'Early Bird Price: £1,699 (with deposit, valid until 29 Apr)\nOriginal Price: £1,898',
            link: 'https://uk.ecoflow.com/pages/generate-checkout?variantId=50633613836627&purchaseOption=690042765651',
        },
        {
            variantId: '50633613803859',
            desc: 'Includes:\n2 × 520W Rigid Solar Panels\n1 × EcoFlow STREAM Ultra',
            tips: 'Ideal for 90–119m² Home Size',
            priceDesc: 'Back to £1,548 on 30 April',
            save: 'Save £341 per Year',
            message: 'Early Bird Price: £1,329 (with deposit, valid until 29 Apr)\nOriginal Price: £1,548',
            link: 'https://uk.ecoflow.com/pages/generate-checkout?variantId=50633613803859&purchaseOption=690042765651',
        },
        {
            variantId: '50633613869395',
            desc: 'Includes:\n4 × 520W Rigid Solar Panels\n1 × EcoFlow STREAM Ultra',
            tips: 'Ideal for 120–149m² Home Size',
            priceDesc: 'Back to £1,997 on 15 May',
            save: 'Save £158 per Year',
            message: 'Early Bird Price: £1,609 (with deposit, valid until 29 Apr)\nOriginal Price: £1,997',
            link: 'https://uk.ecoflow.com/pages/generate-checkout?variantId=50633613869395&purchaseOption=690042765651',
        },
        {
            variantId: '50633613902163',
            desc: 'Includes:\n4 × 520W Rigid Solar Panels\n1 × EcoFlow STREAM Ultra\n2 × EcoFlow STREAM AC Pro',
            tips: 'Solar Energy for Anytime Use',
            priceDesc: 'Back to £3,595 on 15 May',
            save: '0% Waste',
            message: 'Early Bird Price: £3,129(with deposit, valid until 29-Apr)\nOriginal Price: £3,595',
            link: 'https://uk.ecoflow.com/pages/generate-checkout?variantId=50633613902163&purchaseOption=690042765651',
        },
        {
            variantId: '50633613934931',
            desc: 'Includes:\n4 × 520W Rigid Solar Panels\n2 × 450W Rigid Solar Panels\n1 × EcoFlow STREAM Ultra\n3 × EcoFlow STREAM AC Pro\n1 × Microinverter',
            tips: 'Plug & Play Residential Solar Solution',
            priceDesc: 'Back to £4,972 on 15 May',
            save: 'Save £729 per Year',
            message: 'Early Bird Price: £5,299 (with deposit, valid until 29-Apr)\nOriginal Price: £6,071',
            link: 'https://uk.ecoflow.com/pages/generate-checkout?variantId=50633613934931&purchaseOption=690042765651',
        },
    ],
};
